import { removeNulls } from '..';

/**
 * Find the depth of the deepest branch of a ProDirectedTreeNode.
 */
export const getDepthOfDirectedTreeNode = (
    node: ProDirectedTreeNode,
    depthSoFar = 0,
): number => {
    if (node.children === null || node.children === undefined) {
        return depthSoFar;
    }

    const childResults = [];

    for (const child of removeNulls(node.children)) {
        childResults.push(getDepthOfDirectedTreeNode(child, depthSoFar + 1));
    }

    const deepest = childResults.reduce((acc, childResult) => {
        if (childResult > acc) {
            return childResult;
        }

        return acc;
    }, 0);

    return deepest;
};
